import * as type from './constant';

export const getAgencyConfig = (agencyId, selfRole = undefined) => ({
  type: type.GET,
  agencyId,
  selfRole,
});

export const getAgencyConfigSuccess = (payload, agencyId) => ({
  type: type.GET_SUCCESS,
  payload,
  agencyId,
});

export const getAgencyConfigError = (error) => ({
  type: type.GET_ERROR,
  error,
});

export const updateAgencyConfig = (agencyId, payload, selfRole = undefined) => ({
  type: type.UPDATE,
  agencyId,
  payload,
  selfRole,
});

export const updateAgencyConfigSuccess = (payload, agencyId) => ({
  type: type.UPDATE_SUCCESS,
  payload,
  agencyId,
});

export const deleteAgencyConfig = (agencyId, selfRole = undefined) => ({
  type: type.DELETE,
  agencyId,
  selfRole,
});

export const deleteAgencyConfigSuccess = (payload) => ({
  type: type.DELETE_SUCCESS,
  payload,
});

export const manipulationAgencyConfigError = (error) => ({
  type: type.MANIPULATION_ERROR,
  error,
});
